var map = {
	"./KEC Stidents Won First Prize form Education Minister.webp": 77977,
	"./WhatsApp Image 2025-09-21 at 9.05.15 PM.webp": 83705,
	"./WhatsApp Image 2025-10-07 at 3.43.54 PM (1).webp": 68224,
	"./WhatsApp Image 2025-10-07 at 3.43.54 PM (2).webp": 42971,
	"./WhatsApp Image 2025-10-07 at 3.43.54 PM.webp": 52222,
	"./aids,mts.webp": 84666,
	"./chemical.webp": 64827,
	"./chemical1.webp": 73618,
	"./civil&ai.webp": 6418,
	"./ece (2).webp": 47783,
	"./ece.webp": 3578,
	"./it.webp": 33758,
	"./kpitsparkle2024.webp": 56785,
	"./mts.webp": 38575,
	"./mts1.webp": 24494,
	"./mts2.webp": 77839,
	"./sih2024.webp": 71637,
	"./technofest.webp": 87810
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4679;